type ArrowOutType = {
  fill: string
  width: string
  height: string
  title: string
  strokeWidth?: string
  className?: string
}

function ArrowOut(props: ArrowOutType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'upload'
  const strokeWidth = props.strokeWidth || '1.5'
  const className = props.className || ''

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      className={`shrink-0 ${className}`}
    >
      <title>{title}</title>
      <path
        d='M7.49967 4.16797H4.16634C3.01575 4.16797 2.08301 5.10072 2.08301 6.2513V15.8346C2.08301 16.9852 3.01575 17.918 4.16634 17.918H13.7497C14.9003 17.918 15.833 16.9852 15.833 15.8346V12.5013'
        stroke={fill}
        strokeWidth={strokeWidth}
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M11.666 2.08398H17.916V8.33398'
        stroke={fill}
        strokeWidth={strokeWidth}
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M10 10.0007L17.9167 2.08398L17.7905 2.21017'
        stroke={fill}
        strokeWidth={strokeWidth}
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default ArrowOut
